// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__271Lh","error":"Textarea_error__SPvgx","readonly":"Textarea_readonly__Kp_d3","disabled":"Textarea_disabled__3W0Qc"};